const sharedQuestions = {
  q1: { question: "What is the primary purpose of this protocol?" },
  q2: { question: "How does this protocol guide behavior or actions?"},
  q3: { question: "What specific actions or processes does it coordinate?"},
  q4: { question: "How are the rules of this protocol enforced?"},
  q5: { question: "What problem(s) does this protocol aim to solve?"},
  q6: { question: "What are the tradeoffs involved in implementing this protocol?"},
  q7: { question: "What happens when this protocol fails or when someone doesn't follow it?"},
  q8: { question: "How does this protocol interact with or depend on other protocols or systems?"},
  };
  
export default sharedQuestions;  